<template>
  <div id="app">
    <component :is="this.$route.meta.layout || 'div'">
      <Toast position="bottom-right"/>
      <router-view />
    </component>
    <ConfirmDialog></ConfirmDialog>
  </div>
</template>

<script>
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';

export default {
name: 'App',
components: {
  Toast,
  ConfirmDialog
},

metaInfo: {
  title: 'Glør Partner'    
},

data() {
  return {
    layout: 'div',
  };
},
}
</script>

<style lang="sass">
@import 'sass/global.sass'
body
  margin: unset
  background-color: #f0f0f0
  
.container 
  background-color: white


</style>
